import { Autocomplete, TextField } from '@mui/material';
import {
  languageCodes,
  LanguageCode,
  Associate,
} from '@vs-online-only-app/state';

export const getDefaultLanguages = (user?: Associate) => {
  const spokenLanguages = user?.spokenLanguages;

  if (!spokenLanguages) {
    return languageCodes.filter(({ name }) => name === 'English');
  }

  return languageCodes.filter(({ languageCode }) =>
    spokenLanguages.includes(languageCode),
  );
};

type Props = {
  label?: string;
  languages: LanguageCode[];
  onChange: (newLanguages: LanguageCode[]) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  disabled?: boolean;
  error?: boolean;
};
const LanguageSelector = ({
  label = 'Languages',
  languages,
  onChange,
  onBlur,
  onFocus,
  disabled,
  error,
}: Props) => (
  <Autocomplete
    options={languageCodes}
    disabled={disabled}
    value={languages}
    autoHighlight
    getOptionLabel={({ name }) => name}
    onBlur={() => typeof onBlur === 'function' && onBlur()}
    onFocus={() => typeof onFocus === 'function' && onFocus()}
    onChange={(_, selectedValues) => {
      onChange(selectedValues as LanguageCode[]);
    }}
    multiple
    disableCloseOnSelect
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        slotProps={{
          htmlInput: params.inputProps,
        }}
        error={error}
        helperText={error ? 'This field is required' : ''}
      />
    )}
  />
);

export default LanguageSelector;
